module.exports = __webpack_public_path__ + "img/20210701_180126.6e647a08.jpg";